<script>
import axios from "axios";
import TitlePage from "../../components/layout/TitlePage.vue";
import Card from "../../components/ui/Card.vue";
import TIPO_INSPECCION from "../../constants/TiposInspeccion";

const form = () => {
  return {
    despacho_id: undefined,
    aduana_id: undefined,
    tramitador_aduanero_id: undefined,
    tipo_inspeccion_id: undefined,
    estado: "Pendiente",
    fecha_notificacion: undefined,
  };
};

const formExamenFisico = () => {
  return {
    contenedor_id: undefined,
    extraportuario_id: undefined,
    fecha_inspeccion: undefined,
    hora_inspeccion: undefined,
    nombre_fiscalizador: undefined,
    apellido_fiscalizador: undefined,
    numero_sello: undefined,
    comentarios: undefined,
    casillas: [],
  };
};

const formSinAforo = () => {
  return {
    fecha_inspeccion: undefined,
    numero_sello: undefined,
  };
};

const nullables = [
  "aduana_id",
  "extraportuario_id",
  "comentarios",
  "contenedor_id",
];

export default {
  components: { TitlePage, Card },
  data() {
    return {
      form: form(),
      formExamenFisico: formExamenFisico(),
      formSinAforo: formSinAforo(),

      createIsPending: undefined,
      createIsError: undefined,
      createIsSuccess: undefined,
      data: undefined,

      listablesIsPending: undefined,
      listablesIsError: undefined,
      tramitadoresAduaneros: undefined,
      tiposInspeccion: undefined,
      casillasVerificacion: undefined,
      aduanas: undefined,
      estadosAforo: undefined,

      despacho: undefined,
      fetchDespachoIsPending: undefined,
      fetchDespachoIsError: undefined,
      fetchDespachoIsSuccess: undefined,

      aforo: undefined,
      aforoIsPending: undefined,
      aforoIsSuccess: undefined,
      aforoIsError: undefined,

      createIsPending: undefined,
      createIsError: undefined,
      createIsSuccess: undefined,

      tramitadoresAduanaList: [],

      disableSubmit: true,

      currentPhotos: [],
      deletedPhotos: [],
      newPhotos: [],

      currentFiles: [],
      deletedFiles: [],
      newFiles: [],
    };
  },
  methods: {
    async formValid() {
      // MEDIOCRE VALIDATION APPROACH
      for (const [key, value] of Object.entries(this.form)) {
        if (!nullables.includes(key) && !value) return false;
      }
      switch (this.form?.tipo_inspeccion_id) {
        case TIPO_INSPECCION.FISICO:
          for (const [key, value] of Object.entries(this.formExamenFisico)) {
            if (!nullables.includes(key) && !value) return false;
          }
          break;
      }

      return true;
    },
    async parseTramitadoresAduana() {
      this.tramitadoresAduanaList = [];
      if (this.despacho?.tramitadores_aduaneros?.length > 0) {
        this.tramitadoresAduanaList = this.tramitadoresAduanaList.concat(
          this.despacho.tramitadores_aduaneros.map((item) => ({
            value: item.id,
            key: item.name,
          }))
        );
      }
      if (this.despacho?.jefes_operaciones?.length > 0) {
        this.tramitadoresAduanaList = this.tramitadoresAduanaList.concat(
          this.despacho.jefes_operaciones.map((item) => ({
            value: item.id,
            key: item.name,
          }))
        );
      }
    },
    async fetchCurrentAforo() {
      try {
        const { data } = await axios.get(
          `/api/admin/aforos/${this.$route.params.aforoId}`
        );

        if (data?.data) {
          this.aforo = { ...data.data };
        }
      } catch (e) {
        console.error(e);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al obtener los datos del aforo actual.",
        });
      }
    },
    async fetchCurrentDespacho() {
      this.fetchDespachoIsPending = true;
      try {
        const { data } = await axios.get(
          `/api/admin/despachos/${this.aforo?.despacho_id}`
        );

        if (data?.data) {
          this.despacho = { ...data.data };
          this.form.aduana_id = this.despacho?.tipo?.aduana?.id;
          this.fetchDespachoIsSuccess = true;
          this.fetchDespachoIsError = false;

          await this.parseTramitadoresAduana();
        }
      } catch (e) {
        this.fetchDespachoIsSuccess = false;
        this.fetchDespachoIsError = true;
        console.error(e);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema para obtener los datos del despacho actual.",
        });
      }
      this.fetchDespachoIsPending = false;
    },
    async fetchLists() {
      // selector data and shi
      this.listablesIsPending = true;

      const query = {
        params: {
          get: '["tipos_inspeccion", "estados_aforo", "tramitadores_aduaneros", "aduanas", "casillas_verificacion"]',
        },
      };

      const { data } = await axios.get(`/api/list`, query);

      if (data?.data?.tipos_inspeccion) {
        this.tiposInspeccion = [...data.data.tipos_inspeccion];
      }

      if (data?.data?.estados_aforo)
        this.estadosAforo = [...data.data.estados_aforo];
      if (data?.data?.tramitadores_aduaneros)
        this.tramitadoresAduaneros = [...data.data.tramitadores_aduaneros];
      if (data?.data?.casillas_verificacion)
        this.casillasVerificacion = [...data.data.casillas_verificacion];

      this.listablesIsPending = false;
    },
    async updateAforo() {
      this.createIsPending = true;
      const formData = new FormData();

      Object.entries(this.form).forEach((entry) => {
        if (!entry[1]) return;
        formData.append(entry[0], entry[1]);
      });

      switch (this.form.tipo_inspeccion_id) {
        case TIPO_INSPECCION.FISICO:
          Object.entries(this.formExamenFisico).forEach((entry) => {
            if (!entry[1]) return;
            let value = entry[1];
            if (entry[0] === 'hora_inspeccion' && typeof value === 'string' && value.length === 5) {
              value += ':00';
            }
            formData.append(entry[0], value);
          });
          break;
        case TIPO_INSPECCION.SIN_AFORO:
          Object.entries(this.formSinAforo).forEach((entry) => {
            if (!entry[1]) return;
            formData.append(entry[0], entry[1]);
          });
          break;
      }
      Object.entries(this.newPhotos).forEach((entry) => {
        if (!entry[1]) return;
        formData.append(`new_photo[${entry[0]}]`, entry[1]);
      });
      Object.entries(this.deletedPhotos).forEach((entry) => {
        if (!entry[1]) return;
        formData.append(`deleted_photo[${entry[0]}]`, entry[1].id);
      });

      Object.entries(this.newFiles).forEach((entry) => {
        if (!entry[1]) return;
        formData.append(`new_file[${entry[0]}]`, entry[1]);
      });
      Object.entries(this.deletedFiles).forEach((entry) => {
        if (!entry[1]) return;
        formData.append(`deleted_file[${entry[0]}]`, entry[1].id);
      });
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      formData.append("_method", "PATCH");

      try {
        const { data } = await axios.post(
          `/api/admin/aforos/${this.$route.params.aforoId}`,
          formData,
          config
        );
        if (data?.data) {
          this.data = { ...data.data };
        }

        this.$swal({
          icon: "success",
          title: "Actualización de aforo",
          text: "Aforo actualizado exitosamente.",
        });

        this.$router.push({
          name: "despacho-aforo-detalle",
          params: { despachoId: this.despacho?.id, aforoId: this.data?.id },
        });
      } catch (e) {
        this.createIsPending = false;
        this.createIsError = true;
        console.error(e);

        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al actualizar el aforo",
        });
      }

      this.createIsSuccess = true;
      this.createIsPending = false;
    },
    removeCurrentPhoto(photo) {
      this.deletedFiles.push(photo);

      this.currentPhotos = this.currentPhotos.filter(
        (match) => photo.id != match.id
      );
    },
    removeNewPhoto(photo) {
      this.newFiles = this.newFiles.filter((match) => photo.name != match.name);
    },
    removeCurrentFile(file) {
      this.deletedFiles.push(file);

      this.currentFiles = this.currentFiles.filter(
        (match) => file.id != match.id
      );
    },
    removeNewFile(file) {
      this.newFiles = this.newFiles.filter((match) => file.name != match.name);
    },
    async resetForm() {
      this.form.despacho_id = this.aforo?.despacho_id;
      this.form.aduana_id =
        this.aforo?.aduana_id ||
        this.despacho?.aduana_id ||
        this.despacho?.aduana?.id ||
        this.despacho?.tipo?.aduanas_id ||
        this.despacho?.tipo?.aduana?.id;
      this.form.tramitador_aduanero_id = this.aforo?.tramitador_aduanero_id;

      this.form.tipo_inspeccion_id = this.aforo?.tipo_inspeccion?.id;

      this.form.estado = this.aforo?.estado;

      const tmpDate = this.aforo?.fecha_notificacion?.split("-");

      this.form.fecha_notificacion = `${tmpDate[2]}-${tmpDate[1]}-${tmpDate[0]}`;

      if (this.aforo?.tipo_inspeccion?.id == TIPO_INSPECCION.FISICO) {
        this.formExamenFisico.contenedor_id =
          this.aforo.inspectable?.contenedor_id;
        this.formExamenFisico.extraportuario_id =
          this.aforo.inspectable?.extraportuario_id ||
          this.despacho?.extraportuario_id ||
          this.despacho?.extraportuario?.id ||
          this.despacho?.tipo?.extraportuario_id ||
          this.despacho?.tipo?.extraportuario?.id;

        const tmpInspeccionDate =
          this.aforo?.inspectable?.fecha_inspeccion?.split("-");

        this.formExamenFisico.fecha_inspeccion = `${tmpInspeccionDate[2]}-${tmpInspeccionDate[1]}-${tmpInspeccionDate[0]}`;
        this.formExamenFisico.hora_inspeccion =
          this.aforo.inspectable?.hora_inspeccion;
        this.formExamenFisico.nombre_fiscalizador =
          this.aforo.inspectable?.nombre_fiscalizador;
        this.formExamenFisico.apellido_fiscalizador =
          this.aforo.inspectable?.apellido_fiscalizador;
        this.formExamenFisico.numero_sello =
          this.aforo.inspectable?.numero_sello;

        this.formExamenFisico.casillas = this.casillasVerificacion.map(
          (element) => {
            const match = this.aforo.casillas.some(
              (casilla) => casilla.id == element.value
            );

            return match ? element.value : null;
          }
        );

        this.formExamenFisico.comentarios = this.aforo.inspectable?.comentarios;
      } else if (this.aforo?.tipo_inspeccion?.id == TIPO_INSPECCION.SIN_AFORO) {
        console.log(this.aforo)
        const tmpInspeccionDate = this.aforo?.inspectable?.fecha_inspeccion?.split("-");

        this.formSinAforo.fecha_inspeccion = `${tmpInspeccionDate[2]}-${tmpInspeccionDate[1]}-${tmpInspeccionDate[0]}`;
        this.formSinAforo.numero_sello = this.aforo?.inspectable?.numero_sello;
      }

      if (this.aforo.archivos.length > 0) {
        const temp = this.aforo.archivos.map((file) => ({
          id: file.id,
          name: file.ruta?.replace(/^.*[\\/]/, ""),
        }));

        this.currentPhotos = temp.filter(
          (photo) =>
            photo.name?.includes(".png") ||
            photo.name?.includes(".jpg") ||
            photo.name?.includes(".jpeg")
        );
        this.currentFiles = temp.filter(
          (file) => file.name?.includes(".pdf") || file.name?.includes(".xls")
        );
      }
    },
  },
  computed: {
    pending() {
      return (
        this.listablesIsPending ||
        this.aforoIsPending ||
        this.fetchDespachoIsPending
      );
    },
    requiereExamenFisico() {
      return this.form.tipo_inspeccion_id == TIPO_INSPECCION.FISICO;
    },
    sinAforo() {
      return this.form.tipo_inspeccion_id == TIPO_INSPECCION.SIN_AFORO;
    },
    requiereFotos() {
      return this.form.tipo_inspeccion_id != TIPO_INSPECCION.DOCUMENTAL;
    },
  },
  async mounted() {
    await this.fetchLists();
    await this.fetchCurrentAforo();
    await this.fetchCurrentDespacho();
    await this.resetForm();
  },

  watch: {
    "form.tipo_inspeccion_id": function (newVal) {
      //this.resetForm();
      //this.form.tipo_inspeccion_id = newVal;
    },
    form: {
      handler: function () {
        this.disableSubmit = !this.formValid();
      },
      deep: true,
    },
    formExamenFisico: {
      handler: function () {
        this.disableSubmit = !this.formValid();
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <title-page title="Aforos" />
    <card
      title="Editar Aforo"
      segundoboton
      segundotext="Volver"
      :segundoaccionBoton="() => $router.go(-1)"
    >
      <div v-if="!pending">
        <div class="grid grid-cols-1 gap-2">
          <div class="flex flex-row items-center gap-2 justify-between">
            <label>Tipo</label>
            <span class="font-bold uppercase">{{
              despacho?.tipo_despacho ?? "-"
            }}</span>
          </div>
          <div class="flex flex-row items-center gap-2 justify-between">
            <label>Cliente</label>
            <span class="font-bold uppercase">{{
              despacho?.cliente?.nombre ?? "-"
            }}</span>
          </div>
          <div class="flex flex-row items-center gap-2 justify-between">
            <label>Agente</label>
            <span class="font-bold uppercase">{{
              despacho?.agente?.nombre ?? "-"
            }}</span>
          </div>
          <div class="flex flex-row items-center gap-2 justify-between">
            <label>Aduana</label>
            <span class="font-bold uppercase">{{
              despacho?.tipo?.aduana?.nombre ?? "-"
            }}</span>
          </div>
          <div class="flex flex-row items-center gap-2 justify-between">
            <label>Extraportuario</label>
            <span class="font-bold uppercase">{{
              despacho?.tipo?.extraportuario?.nombre ?? "-"
            }}</span>
          </div>
        </div>
        <hr />
        <div
          class="flex flex-col text-left gap-12 sm:w-[80%] xl:w-[60%] mx-auto my-[2%]"
        >
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-16">
            <div class="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div class="">
                <label>Tipo de inspección</label>
                <select disabled v-model="form.tipo_inspeccion_id">
                  <option
                    v-for="tipoInspeccion in tiposInspeccion"
                    :key="tipoInspeccion.value"
                    :value="tipoInspeccion.value"
                  >
                    {{ tipoInspeccion.key }}
                  </option>
                </select>
              </div>
              <div class="">
                <label for="">Tramitador Aduana</label>
                <select v-model="form.tramitador_aduanero_id">
                  <option
                    v-for="tramitador in tramitadoresAduanaList"
                    :key="tramitador.value"
                    :value="tramitador.value"
                  >
                    {{ tramitador.key }}
                  </option>
                </select>
              </div>

              <div>
                <label for="">Estado</label>
                <select v-model="form.estado">
                  <option v-for="estado in estadosAforo" :key="estado">
                    {{ estado }}
                  </option>
                </select>
              </div>

              <div>
                <label for="">{{ sinAforo ? 'Fecha de inspección' : 'Fecha de notificación' }}</label>
                <b-datepicker v-if="!sinAforo" v-model="form.fecha_notificacion" />
                <b-datepicker v-if="sinAforo" v-model="formSinAforo.fecha_inspeccion" />
              </div>
            </div>

            <div
              v-if="sinAforo"
              class="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4"
            >
              <div>
                <label>N° sello</label>
                <input type="number" v-model="formSinAforo.numero_sello" />
              </div>
            </div>

            <div
              v-if="requiereExamenFisico"
              class="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4"
            >
              <div>
                <label>Fecha de Inspección</label>
                <b-datepicker v-model="formExamenFisico.fecha_inspeccion" />
              </div>
              <div>
                <label>Hora de Inspección</label>
                <input 
                  type="time" 
                  class="time-input-icon-left"
                  v-model="formExamenFisico.hora_inspeccion" 
                />
              </div>

              <div>
                <label>Nombre fiscalizador</label>
                <input v-model="formExamenFisico.nombre_fiscalizador" />
              </div>
              <div>
                <label>Apellido fiscalizador</label>
                <input v-model="formExamenFisico.apellido_fiscalizador" />
              </div>

              <div>
                <label>N° sello</label>
                <input type="number" v-model="formExamenFisico.numero_sello" />
              </div>

              <div class="sm:col-span-2 flex flex-col gap-4">
                <h1 class="!font-bold !text-lg">Casillas de verificación</h1>

                <div
                  v-for="(casilla, i) in casillasVerificacion"
                  :key="i"
                  class="flex flex-row items-center gap-4"
                >
                  <input
                    type="checkbox"
                    v-model="formExamenFisico.casillas[i]"
                    :true-value="casilla.value"
                    :false-value="null"
                  />
                  <label class="my-auto w-full">{{ casilla.key }}</label>
                </div>

                <hr />
              </div>

              <div class="sm:col-span-2">
                <h1 class="!text-lg !font-bold">Comentarios</h1>
                <textarea
                  type="number"
                  v-model="formExamenFisico.comentarios"
                  rows="5"
                  class="min-h-18"
                />
              </div>
            </div>

            <div
              v-if="requiereFotos"
              class="sm:col-span-2 flex flex-col gap-4"
            >
              <h1 class="!text-lg !font-bold">Fotos</h1>
              <p class="text-sm">Las fotos no deben superar los 2MB.</p>

              <div>
                <b-form-file
                  browse-text="Adjuntar"
                  placeholder="Seleccione un archivo"
                  drop-placeholder="Coloque el archivo aqui..."
                  multiple
                  type="file"
                  accept="image/jpeg, image/png"
                  @change="
                    (event) => {
                      newPhotos = Array.from(event.target.files);
                    }
                  "
                />
              </div>

              <ul class="flex flex-col gap-4">
                <li
                  v-for="(currentPhoto, i) in currentPhotos"
                  :key="i + '_current_file'"
                  class="flex flex-row gap-4"
                >
                  <span>{{ currentPhoto.name }}</span>
                  <fas
                    :icon="['fas', 'trash']"
                    class="hover:scale-110 transition-all cursor-pointer"
                    @click="removeCurrentPhoto(currentPhoto)"
                  />
                </li>

                <li
                  v-for="(newPhoto, i) in newPhotos"
                  :key="i + '_new_file'"
                  class="flex flex-row gap-4"
                >
                  <span>{{ newPhoto.name }}</span>
                  <fas
                    :icon="['fas', 'trash']"
                    class="hover:scale-110 transition-all cursor-pointer"
                    @click="removeNewPhoto(newPhoto)"
                  />
                </li>
              </ul>
            </div>

            <div class="sm:col-span-2 flex flex-col gap-4">
              <h1 class="!text-lg !font-bold">Carpeta</h1>
              <p class="text-sm">Los archivos no deben superar los 8MB.</p>
              <div>
                <b-form-file
                  browse-text="Adjuntar"
                  placeholder="Seleccione un archivo"
                  drop-placeholder="Coloque el archivo aqui..."
                  multiple
                  type="file"
                  accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="
                    (event) => {
                      newFiles = Array.from(event.target.files);
                    }
                  "
                />
              </div>

              <ul class="flex flex-col gap-4">
                <li
                  v-for="(currentFile, i) in currentFiles"
                  :key="i + '_current_file'"
                  class="flex flex-row gap-4"
                >
                  <span>{{ currentFile.name }}</span>
                  <fas
                    :icon="['fas', 'trash']"
                    class="hover:scale-110 transition-all cursor-pointer"
                    @click="removeCurrentFile(currentFile)"
                  />
                </li>

                <li
                  v-for="(newFile, i) in newFiles"
                  :key="i + '_new_file'"
                  class="flex flex-row gap-4"
                >
                  <span>{{ newFile.name }}</span>
                  <fas
                    :icon="['fas', 'trash']"
                    class="hover:scale-110 transition-all cursor-pointer"
                    @click="removeNewFile(newFile)"
                  />
                </li>
              </ul>
            </div>
          </div>

          <div class="">
            <button
              type="button"
              class="btn-principal ml-auto"
              @click="() => updateAforo()"
              :disabled="createIsPending"
            >
              Actualizar
            </button>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="m-auto p-8">
          <b-spinner
            class="text-primary mx-auto"
            style="width: 3em; height: 3em"
          ></b-spinner>
        </div>
      </div>
    </card>
  </div>
</template>

<style scoped>
.time-input-icon-left {
  position: relative;
  padding-left: 2.5rem;
}

.time-input-icon-left::-webkit-calendar-picker-indicator {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
  padding: 0;
  cursor: pointer;
}
</style>
